import React from 'react';
import { isFunction, isObject } from 'lodash';

export function isValidComponent(Component: React.ComponentType): boolean {
    if (!isFunction(Component) && !isObject(Component)) return false;
    if (!React.isValidElement(Component) && !Component.displayName) return false;

    return true;
}
